import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const useDevice = (
  breakpoints = { desktop: 1600, tablet: 1024, mobile: 767 },
) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;

      setIsDesktop(windowWidth > breakpoints.tablet);
      setIsTablet(
        windowWidth <= breakpoints.tablet && windowWidth > breakpoints.mobile,
      );
      setIsMobile(windowWidth <= breakpoints.mobile);
    };

    if (typeof window !== 'undefined') {
      handleResize();
    }

    const debounced = debounce(handleResize, 100);

    window.addEventListener('resize', debounced);

    return () => {
      window.removeEventListener('resize', debounced);
    };
  }, [breakpoints]);

  return { isDesktop, isTablet, isMobile };
};

export default useDevice;
